import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaHasEnterpriseOrPremiumLicense" */ './lazyIndex'),
    { name: 'OwaHasEnterpriseOrPremiumLicense' }
);

export const lazyHasEnterpriseOrPremiumLicense: LazyAction<
    typeof lazyIndex.hasEnterpriseOrPremiumLicense,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.hasEnterpriseOrPremiumLicense);

export const lazyIsLastMailboxInfoProvidesEnterpriseOrPremiumLicense: LazyAction<
    typeof lazyIndex.isLastMailboxInfoProvidesEnterpriseOrPremiumLicense,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isLastMailboxInfoProvidesEnterpriseOrPremiumLicense);
